import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useNewTransactionStore } from "@repo/core/stores/newTransaction";
import { ROUTES } from "@repo/core/routes";
import { ClientInfoSectionProps } from "@repo/core/components/receipt/sections/ClientInfoSection/types";
import { TransactionInfoSectionProps } from "@repo/core/components/receipt/sections/TransactionInfoSection/types";
import { useNewTransactionFlow } from "@repo/core/hooks/useNewTransactionFlow";
import { TransactionFlowType } from "@repo/core/screens/NewTransaction/types";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";
import { useGeneratePdf } from "@repo/core/hooks/useGeneratePdf";

export const NewTransactionReceiptController = () => {
  // Hooks
  const { replace } = useNavigation();
  const { isMobile } = useDimensions();
  const { currentRouteConfig } = useNewTransactionFlow();
  const { viewRef, handleCaptureAndGeneratePDF, isLoading } = useGeneratePdf();

  // Store
  const {
    transactionValue,
    selectedInstallment,
    discountedTransactionValue,
    selectedProduct,
    resetNewTransaction,
    transactionOperation,
    flowType,
    bonusValue
  } = useNewTransactionStore();

  const { selectedStore } = useStoresAndShopkeepersStore();

  // Calculations
  const isInterestGreaterThanZero =
    selectedInstallment?.dblValorCompra &&
    discountedTransactionValue &&
    selectedInstallment.dblValorCompra - discountedTransactionValue > 0;

  const transactionInfo: TransactionInfoSectionProps = {
    title: "Dados Gerais",
    icon: "list",
    dateTime: new Date(),
    value:
      flowType === TransactionFlowType.BONUS_RETRIEVAL
        ? bonusValue || 0
        : transactionValue,
    interestValue:
      selectedInstallment && isInterestGreaterThanZero
        ? selectedInstallment.dblValorCompra - discountedTransactionValue
        : undefined,
    totalValue:
      flowType === TransactionFlowType.BONUS_RETRIEVAL
        ? bonusValue || 0
        : selectedInstallment?.dblValorCompra || discountedTransactionValue,
    installmentsQuantity: selectedInstallment?.intPrazo,
    installmentValue: selectedInstallment?.dblValorPrestacao,
    operation: transactionOperation
  };

  const clientInfo: ClientInfoSectionProps = {
    title: "Origem",
    icon: "circle-arrow-up",
    name: selectedProduct?.strNomePortador || "",
    card: selectedProduct?.strPlasticoTitularNumero
      ? `••••${selectedProduct.strPlasticoTitularNumero.slice(-4)}`
      : "",
    fone: ""
  };

  // Navigation Handlers
  const handleNavigateToHome = () => {
    replace(ROUTES.home);
    resetNewTransaction();
  };

  const handleNavigateToSales = () => {
    replace(ROUTES.sales);
    resetNewTransaction();
  };

  return {
    // Layout
    isMobile,

    // Data
    transactionInfo,
    clientInfo,
    title: currentRouteConfig.title,
    selectedStore,
    viewRef,
    isLoading,

    // Handlers
    handleBack: handleNavigateToHome,
    handleGoToSales: handleNavigateToSales,
    handleCaptureAndGeneratePDF
  };
};
